import { Button } from 'antd'
import CustomTable from '../../../../elements/Table/CustomTable'
import React from 'react'

function DeliveryStopsList(props) {
  const { list, isUpdatable, fetch, fetching, onShow } = props

  const columns = [
    { Header: 'No', accessor: '_key' },
    { Header: 'Package', accessor: 'package.code' },
    { Header: 'address', accessor: 'location.address.label' },
    { Header: 'country', accessor: 'location.country' },
    { Header: 'Location Code', accessor: 'location.location' },
    {
      Header: 'Stop Type',
      accessor: 'isStart',
      Cell: ({ original }) => {
        return original.isStart ? 'Start' : original.isEnd ? 'End' : 'Intermediate Stop'
      },
    },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={!isUpdatable}>
          New Delivery
        </Button>
      )}
      columns={columns}
    />
  )
}

DeliveryStopsList.propTypes = {}
DeliveryStopsList.defaultProps = {}

export default DeliveryStopsList
